/** Base para errores reconocibles del dominio Customer (UI puede mapear por `code`). */
export class CustomerDomainError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = new.target.name;
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

function customerErrorClass(name: string, code: string, defaultMessage: string) {
  return class extends CustomerDomainError {
    constructor(message = defaultMessage) {
      super(code, message);
      this.name = name;
    }
  };
}

export const CustomerCreditLimitExceededError = customerErrorClass(
  'CustomerCreditLimitExceededError',
  'customer_credit_limit_exceeded',
  'El consumo supera el límite de crédito. Pedí autorización de supervisor.'
);

export const CustomerBlockedError = customerErrorClass(
  'CustomerBlockedError',
  'customer_blocked',
  'Este cliente está bloqueado. No podés registrar consumos hasta desbloquearlo.'
);

export const CustomerNotFoundError = customerErrorClass(
  'CustomerNotFoundError',
  'customer_not_found',
  'Cliente no encontrado.'
);
